export enum YesNo {
  YES = 'yes',
  NO = 'no',
}

/**
 * Converts a boolean to a string of 'yes' or 'no' or an empty string if the boolean is null or undefined
 * @param value - The boolean to convert
 * @returns The string 'yes' or 'no'
 */
export function convertBooleanToYesNoEmpty(value: boolean | null | undefined): string {
  if (value === undefined || value === null) {
    return ''
  }
  return value ? YesNo.YES : YesNo.NO
}

/**
 * Converts a string of 'yes' or 'no' to a boolean or null
 * @param value - The string to convert
 * @returns The boolean true or false or null if the string is not 'yes' or 'no'
 */
export function convertYesNoEmptyToBoolOrNull(value: string | null | undefined): boolean | null {
  switch (value) {
    case null:
    case undefined:
      return null
    case YesNo.YES:
      return true
    case YesNo.NO:
      return false
    default:
      return null
  }
}
